var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "navigation" } },
    [
      _c("div", {
        staticClass: "vo-scrim",
        class: {
          active: _vm.$route.query.account || _vm.$route.query.activity
        },
        on: {
          click: function($event) {
            _vm.routeRemoveQueries(["account", "activity"])
          }
        }
      }),
      _vm._v(" "),
      _c("transition", { attrs: { name: "account-menu" } }, [
        _vm.$route.query.account
          ? _c(
              "div",
              { staticClass: "account-menu" },
              _vm._l(_vm.app.accountNav, function(option, i) {
                return _c(
                  "div",
                  {
                    directives: [{ name: "ripple", rawName: "v-ripple" }],
                    key: i,
                    staticClass: "option",
                    on: {
                      click: function($event) {
                        _vm.optionClicked(option)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "icon-item" },
                      [_c("v-icon", [_vm._v(_vm._s(option.icon))])],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "name" }, [
                      _vm._v(_vm._s(option.title))
                    ])
                  ]
                )
              })
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "nav-bar" }, [
        _c("div", { staticClass: "logo" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "nav-items" },
          _vm._l(_vm.app.navigation, function(page, i) {
            return _vm.hasPermissions(page.permissions)
              ? _c(
                  "div",
                  {
                    directives: [{ name: "ripple", rawName: "v-ripple" }],
                    key: i,
                    staticClass: "nav-item",
                    class: { selected: _vm.isSelected(page) },
                    on: {
                      click: function($event) {
                        _vm.updatePage(page)
                      }
                    }
                  },
                  [_vm._v("\n        " + _vm._s(page.title) + "\n      ")]
                )
              : _vm._e()
          })
        ),
        _vm._v(" "),
        _c("div", { staticClass: "right-section" }, [
          _c(
            "div",
            { staticClass: "activity-button" },
            [
              _c(
                "v-btn",
                {
                  attrs: { fab: "", small: "", flat: "" },
                  on: { click: _vm.openKnowledgeBase }
                },
                [
                  _c("v-icon", { staticClass: "icon", attrs: { medium: "" } }, [
                    _vm._v("mdi-help-circle")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { fab: "", small: "", flat: "" },
                  on: {
                    click: function($event) {
                      _vm.toggle("activity")
                    }
                  }
                },
                [
                  _c("v-icon", { staticClass: "icon", attrs: { medium: "" } }, [
                    _vm._v("mdi-bell")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("transition", { attrs: { name: "activity" } }, [
                _vm.$route.query.activity
                  ? _c("div", {
                      staticClass: "booper-nib",
                      attrs: { name: "account-menu" }
                    })
                  : _vm._e()
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "account",
              on: {
                click: function($event) {
                  _vm.toggle("account")
                }
              }
            },
            [
              _c("vo-avatar", {
                staticClass: "avatar",
                attrs: { user: _vm.$store.getters.profile, size: 40 }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "name" }, [
                _vm._v(_vm._s(_vm.$store.getters.profile.fullName))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "icon-item" }, [
                _c("i", {
                  staticClass: "mdi mdi-chevron-down mdi-36px",
                  class: { "mdi-flip-v": _vm.$route.query.account }
                })
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "clear" })
        ])
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "activity" } }, [
        _vm.$route.query.activity
          ? _c(
              "div",
              { staticClass: "activity-holder" },
              [_c("vo-activity")],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-81440b78", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81440b78","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation.vue
// module id = 521
// module chunks = 4